// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "@/components/ui/sidebar";

/** Closes the mobile sidebar sheet when the route changes. */
export function MobileSidebarCloser() {
  const { pathname } = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [pathname, isMobile, setOpenMobile]);

  return null;
}
